import { useState, useEffect } from "react";

import {
  Drawer,
  Button,
  Form,
} from "../../design";
import { translate } from "../../utils/translations";
import { COUNTRY_OPTIONS, PROVINCE_OPTIONS } from '../../utils/countries';

function EditShippingAddressDrawer(props: any) {
  const [shippingAddress, setshippingAddress] = useState(null);
  const [provincesOptions, setprovincesOptions] = useState([]);

  const handleConfirm = async () => {
    props.handleConfirm(shippingAddress);
    props.toggleActive();
  };

  useEffect(() => {
    setshippingAddress({ ...props.shippingAddress })
    if (props.shippingAddress?.country_code) {
      setprovincesOptions(PROVINCE_OPTIONS[props.shippingAddress?.country_code])
    }
  }, [props.shippingAddress]);

  return (
    <Drawer id="edit-shipping" title={translate('shipping_edit_drawer_header')} active={props.active} toggleActive={props.toggleActive}>
      <Drawer.Body>
        {shippingAddress ? (
          <>
            <div className="col my-2">
              <Form.Select
                label={translate('shipping_country_label')}
                options={COUNTRY_OPTIONS}
                value={shippingAddress.country_code}
                onChange={(event: any) => {
                  let _old = { ...shippingAddress }
                  _old.country_code = event.target.value
                  _old.province_code = ''
                  if (PROVINCE_OPTIONS[_old.country_code].length > 0) {
                    _old.province_code = PROVINCE_OPTIONS[_old.country_code][0].value
                  }
                  setshippingAddress(_old)
                  setprovincesOptions(PROVINCE_OPTIONS[_old.country_code])
                }}
              />
            </div>
            <div className="row">
              <div className="col my-2">
                <Form.Input
                  label={translate('shipping_first_name_label')}
                  value={shippingAddress.first_name}
                  onChange={(val: any) => {
                    let _old = { ...shippingAddress }
                    _old.first_name = val.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
              <div className="col my-2">
                <Form.Input
                  label={translate('shipping_last_name_label')}
                  value={shippingAddress.last_name}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.last_name = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col">
                <Form.Input
                  label={translate('shipping_phone_label')}
                  value={shippingAddress.phone}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.phone = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col">
                <Form.Input
                  label={translate('company_label')}
                  value={shippingAddress.company}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.company = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
            </div>
            <div className="row my-3">
              <div className="col">
                <Form.Input
                  label={translate('shipping_address_label')}
                  value={shippingAddress.address1}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.address1 = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col">
                <Form.Input
                  label={translate('shipping_apartment_label')}
                  value={shippingAddress.address2}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.address2 = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col my-2">
                <Form.Input
                  label={translate('shipping_city_label')}
                  value={shippingAddress.city}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.city = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
              <div className="col my-2">
                <Form.Input
                  label={translate('shipping_zip_label')}
                  value={shippingAddress.zip}
                  onChange={(event: any) => {
                    let _old = { ...shippingAddress }
                    _old.zip = event.target.value
                    setshippingAddress(_old)
                  }}
                />
              </div>
              {provincesOptions.length > 0 ? (
                <div className="col my-2" style={{maxWidth:"200px"}}>
                  <Form.Select
                    label={translate('shipping_province_label')}
                    options={provincesOptions}
                    value={shippingAddress.province_code}
                    onChange={(event: any) => {
                      let _old = { ...shippingAddress }
                      _old.province_code = event.target.value
                      setshippingAddress(_old)
                    }}
                  />
                </div>
              ) : null}
          </div>
          </>
        ) : null}
      </Drawer.Body>
      <Drawer.Footer>
        <div className="d-flex flex-column">
          <Button size="lg" className="m-2" onClick={handleConfirm}>{translate('shipping_edit_drawer_save_button')}</Button>
          <Button size="lg" variant="underline" className="m-2" onClick={props.toggleActive}>{translate('shipping_edit_drawer_cancel_button')}</Button>
        </div>
      </Drawer.Footer>
    </Drawer>
  )
}


export default EditShippingAddressDrawer;
